export default [
  '#84594E',
  '#519E3E',
  '#7F7F7F',
  '#3B75AF',
  '#58BBCC',
  '#C53932',
  '#C9670D',
  '#BCBD45',
  '#D57DBE',
  '#845BB4',
  '#799A32',
  '#EF8635',
  '#5392EE',
  '#D6A179',
  '#45BD7C',
  '#6170BF',
  '#E46144',
  '#9E893E',
  '#D857CB',
  '#78B5A3',
  '#C2674F',
  '#65B09E',
  '#A6A6A6',
  '#606CDA',
  '#469EF0',
  '#AC4D4D',
  '#CAB961',
  '#81B25B',
  '#A25EA6',
  '#CA9081',
  '#567859',
  '#93A8AB',
  '#AEA976',
  '#81749C',
  '#C886B9',
  '#DF6868',
  '#60C353',
  '#C97717',
  '#437B6A',
  '#6CA7B5',
  '#BC5C8A',
  '#7558B4',
  '#CB7B7B',
  '#BFB660',
  '#35A9B0',
  '#8B465F',
  '#867C79',
  '#359414',
  '#7E301B',
  '#C53932',
  '#C9670D',
  '#BFCCD8',
  '#E8BB1F',
];
